import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  boxDetails: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    borderRadius: 10
  }
}))

export default useStyles
